import { __assign } from "tslib";
import { pipe, map } from 'wonka';
// return the field types but when given an array (of interface implementations), return merged
// fields -> all possible field names with types.
// XXX we assume you have not defined two types with same field name but different type. 
var allFieldTypes = function (typesMap, curType) {
    if (curType instanceof Array) {
        return curType.map(function (t) { return typesMap[t]; }).reduce(function (a, x) { return Object.assign(a, x); }, {});
    }
    else {
        return typesMap[curType] || {};
    }
};
var objectTypename = function (data) {
    var p = data;
    if (p instanceof Array) {
        if (p.length > 0)
            p = p[0];
        else
            return;
    }
    if (p instanceof Object && p.__typename)
        return p.__typename;
    return;
};
var serializeTree = function (data, serializeOrDeserialize, 
//variables: any,
//varName: string,
initialType, typesMap, serializers) {
    //walk data recursively
    var serialize = function (ptr, curType) {
        // no data beyond that point.
        if (ptr === null || ptr === undefined)
            return ptr;
        if (typeof curType === 'string' && curType in serializers) {
            // Leaf of scalar map tree - means we arrived at the place where scalar is, lets (de)serialize
            return serializeOrDeserialize
                ? serializers[curType].serialize(ptr)
                : serializers[curType].deserialize(ptr);
        }
        else {
            // nested element - for array, we do not traverse the tree deeper
            if (Array.isArray(ptr)) {
                return ptr.map(function (elem) { return serialize(elem, curType); });
                // object, we might have to fork here so call recursively on all the keys of cur tree node
            }
            else if (typeof ptr === 'object') {
                var changed = __assign({}, ptr);
                var fieldTypes = allFieldTypes(typesMap, curType);
                for (var _i = 0, _a = Object.entries(ptr); _i < _a.length; _i++) {
                    var _b = _a[_i], field = _b[0], fieldValue = _b[1];
                    if (fieldValue === null)
                        continue;
                    var fieldType = fieldTypes[field] || objectTypename(fieldValue);
                    if (fieldType === undefined)
                        continue;
                    changed[field] = serialize(ptr[field], fieldType);
                }
                return changed;
            }
            else {
                // for anything else, just return it
                return ptr;
            }
        }
    };
    return serialize(data, initialType);
};
// Use 'any' to avoid graphql version conflicts between different packages in monorepo
var unpackType = function (varType) {
    if (varType.kind === 'NamedType')
        return varType.name.value;
    if (varType.kind === 'ListType' || varType.kind === 'NonNullType')
        return unpackType(varType.type);
    throw new Error("Unsupported variable type node: ".concat(varType));
};
var createSerializeScalarsExchange = function (scalarLocations, serializers) { return function (_a) {
    var forward = _a.forward;
    var serializeArgs = function (op) {
        if (op.kind !== 'query' && op.kind !== 'mutation')
            return op;
        // PersistedDocument doesn't have definitions, only DocumentNode does
        if (!('definitions' in op.query))
            return op;
        for (var _i = 0, _a = op.query.definitions; _i < _a.length; _i++) {
            var def = _a[_i];
            if (def.kind === 'OperationDefinition' && def.variableDefinitions) {
                for (var _b = 0, _c = def.variableDefinitions; _b < _c.length; _b++) {
                    var varDef = _c[_b];
                    var typeName = unpackType(varDef.type);
                    var varName = varDef.variable.name.value;
                    if (typeName in scalarLocations.inputObjectFieldTypes) {
                        // @ts-ignore
                        op.variables[varName] = serializeTree(
                        // @ts-ignore
                        op.variables[varName], true, typeName, scalarLocations.inputObjectFieldTypes, serializers);
                    }
                    if (typeName in serializers) {
                        // @ts-ignore
                        op.variables[varName] = serializers[typeName].serialize(op.variables[varName]);
                    }
                }
            }
        }
        return op;
    };
    var deserializeResult = function (op) {
        if (op.data === null ||
            op.data === undefined ||
            !(op.operation.kind === 'query' || op.operation.kind === 'mutation'))
            return op;
        var dataCopy = __assign({}, op.data);
        for (var _i = 0, _a = Object.entries(op.data); _i < _a.length; _i++) {
            var _b = _a[_i], opName = _b[0], opData = _b[1];
            if (opData === null)
                continue;
            var opType = scalarLocations.operationMap[opName] || objectTypename(opData);
            if (opType === undefined)
                continue;
            dataCopy[opName] = serializeTree(opData, false, opType, scalarLocations.outputObjectFieldTypes, serializers);
        }
        op.data = dataCopy;
        return op;
    };
    return function (ops$) {
        return pipe(ops$, map(serializeArgs), forward, map(deserializeResult));
    };
}; };
export default createSerializeScalarsExchange;
//# sourceMappingURL=index.js.map